export default __webpack_public_path__ + "static/softsale-two-image-b1910f986c0cbd492ccbb452ff2d2a53.png";